import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["anyCheckbox", "optionCheckbox"]

  connect() {
    this.updateCheckboxStates()
  }

  toggleAny(event) {
    const anyCheckbox = event.target

    if (anyCheckbox.checked) {
      // If "Any" is checked, uncheck all other options
      this.optionCheckboxTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
  }

  toggleOption() {
    // Check if any options are checked
    const anyOptionsChecked = this.optionCheckboxTargets.some(checkbox => checkbox.checked)

    // If no options are checked, check "Any"
    // If any options are checked, uncheck "Any"
    this.anyCheckboxTarget.checked = !anyOptionsChecked
  }

  updateCheckboxStates() {
    const anyOptionsChecked = this.optionCheckboxTargets.some(checkbox => checkbox.checked)
    if (!anyOptionsChecked) {
      this.anyCheckboxTarget.checked = true
    }
  }
}
